import * as React from "react";
import { Row, Col, Container } from "react-bootstrap";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { useMediaQuery } from "@react-hook/media-query";
import "../../styles/components/our_vision.scss";

const OurVision = ({ block }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const {
    backgroundColor,
    subtitle,
    textLeftCol,
    title,
    bigImage,
    bigImageMobile,
    firstImage,
    firstImageMobile,
    secondImage,
    secondImageMobile,
  } = block;
  // console.log(block);

  const image1 = isMobile ? bigImageMobile : bigImage;
  const image2 = isMobile ? firstImageMobile : firstImage;
  const image3 = isMobile ? secondImageMobile : secondImage;

  return (
    <div
      style={{
        backgroundColor: `${backgroundColor}`,
        paddingTop: "300px",
      }}
      className="ourvision-m"
    >
      <Container className="ourvision-section max-container">
        <Row className="w-100 m-auto justify-content-center">
          <h2 className="h1 mb-4 font-weight-light ps-0">{title}</h2>
          <p className="mb-1 ps-0">{subtitle?.data?.subtitle}</p>
          <GatsbyImage
            className="my-4"
            image={getImage(image1?.localFile)}
            alt="blocks-img"
          />
        </Row>
        <Row className="w-100 m-auto justify-content-center">
          <Col className="p-0 col-11 col-md-6">
            <div
              className="me-3"
              dangerouslySetInnerHTML={{
                __html: textLeftCol?.data?.childMarkdownRemark?.html,
              }}
            />
          </Col>
          <Col className="p-0 col-11 col-md-6">
            <GatsbyImage
              className="mb-2"
              image={getImage(image2?.localFile)}
              alt="our vision image"
            />
            <GatsbyImage
              className="mt-2"
              image={getImage(image3?.localFile)}
              alt="our vision image"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default OurVision;
